import React from "react";
import Header from "../Components/Common/Header";
import StatCard from "../Components/Common/StatCard";
import LeaveTable from "../Components/Admin/LeaveTable";
import "../Styles/Admin/LeavePage.css"; 
import { CalendarDays, UserCheck, UserX, UserPlus } from "lucide-react";
import { API_BASE_URL } from "../apiConfig";
import { useState,useEffect } from "react";
const LeavePage = () => {
  const [leaveStats, setLeaveStats] = useState({
    totalRequests: 0,
    approvedRequests: 0,
    pendingRequests: 0,
    rejectedRequests: 0,
  });
  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    const fetchLeaveData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/leaves`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
        });
          if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          window.location.href = '/';
          return;
        }
        const data = await response.json();
        if (data.success) {
          setLeaves(data.leaves);

          // Calculate leave stats
          const totalRequests = data.leaves.length;
          const pendingRequests = data.leaves.filter((leave) => 
  leave.status.toLowerCase() === "pending").length;

         const approvedRequests = data.leaves.filter((leave) => 
  leave.status.toLowerCase() === "approved").length;
const rejectedRequests = data.leaves.filter((leave) => 
  leave.status.toLowerCase() === "rejected").length;


          setLeaveStats({
            totalRequests,
            approvedRequests,
            pendingRequests,
            rejectedRequests,
          });
        } else {
          console.error("Failed to fetch leave data:", data.message);
        }
      } catch (err) {
        console.error("Error fetching leave data:", err);
      }
    };

    fetchLeaveData();
  }, []);
  return (
    <div className="leave-page-container">
      <div className="ap-wrap-content">
        <Header title="Leave Management" description="Track and manage employee leave requests" icon={<CalendarDays size={28} color="#f3f4f6"/>}/>

      <main className="leave-main">
        {/* Leave Statistics */}
        <div className="leave-stats-grid">
          <StatCard
            name="Total Requests"
            icon={CalendarDays}
            value={leaveStats.totalRequests}
            color="#6366F1"
          />
          <StatCard
            name="Approved Requests"
            icon={UserCheck}
            value={leaveStats.approvedRequests}
            color="#10B981"
          />
          <StatCard
            name="Pending Requests"
            icon={UserPlus}
            value={leaveStats.pendingRequests}
            color="#F59E0B"
          />
          <StatCard
            name="Rejected Requests"
            icon={UserX}
            value={leaveStats.rejectedRequests}
            color="#EF4444"
          />
        </div>

        {/* Leave Requests Table */}
        <LeaveTable leaves={leaves} setLeaves={setLeaves} />
      </main>
      </div>
    
    </div>
  );
};

export default LeavePage;